import BiotechIcon from '@mui/icons-material/Biotech'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import { Box, Divider, IconButton, Popover, Tooltip, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import algo from '../../core/Algo'
import { IApprovalRequest } from '../../definitions/Approval'
import { IFlow, INode } from '../../definitions/Nodes'
import Helper from '../../helpers/Helper'
import SmartCard from '../controls/cards/SmartCard'
import NodeDryRunConfigEditor from './nodes_editor/NodeDryRunConfigEditor'

interface P {
    selectedNode: INode
    flow: IFlow
    setSelected: (node: INode) => void
    approval: IApprovalRequest
}

const NodeDryRunConfig = ({ selectedNode, flow, setSelected, approval }: P) => {
    const theme = useTheme()
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null)
    const canEdit = approval.status === 'draft' || approval.status === 'rejected'

    return (
        <Box>
            <Tooltip title='Open dry-run config' arrow>
                <IconButton
                    size='small'
                    color='primary'
                    disabled={!canEdit}
                    sx={{ backgroundColor: algo.hasVal(anchorEl) && Helper.hexToRgbA(theme.palette.primary.main, 0.3) }}
                    onClick={e => algo.hasVal(anchorEl) ? setAnchorEl(null) : setAnchorEl(e.currentTarget)}>
                    <BiotechIcon color='action' />
                </IconButton>
            </Tooltip>
            <Popover
                open={algo.hasVal(anchorEl)}
                anchorEl={anchorEl}
                disableEnforceFocus={true}
                disableAutoFocus={true}
                sx={{ top: 'calc(-1 * var(--unit) * 6)', left: 'calc(-1 * var(--unit) * 4)', pointerEvents: 'none' }}
                slotProps={{ paper: { sx: { pointerEvents: 'auto' } } }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <SmartCard sx={{ width: '20vw', maxHeight: '80vh' }}>
                    <Box position='sticky' top={0} right={0} sx={{ backgroundColor: theme.palette.background.default }}>
                        <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' paddingBottom={1} padding={2} sx={{ backgroundColor: theme.palette.background.default }}>
                            <Box display='flex' flexDirection='row' alignItems='center'>
                                <BiotechIcon fontSize='large' color='dryRun' />
                                <Typography marginLeft={1}>Dry Run Config</Typography>
                            </Box>
                            <Tooltip title='Close dry-run config' arrow>
                                <IconButton onClick={() => setAnchorEl(null)}>
                                    <KeyboardDoubleArrowRightIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Divider />
                    </Box>
                    <Box padding={2} overflow='auto' flex={1}>
                        <NodeDryRunConfigEditor selectedNode={selectedNode} flow={flow} setSelected={setSelected} disable={false} />
                    </Box>
                </SmartCard>
            </Popover>
        </Box>
    )
}

export default NodeDryRunConfig
